import React from 'react';
import { Box } from '@material-ui/core';
import { useErrorNotification } from '../../contexts/ErrorNotificationContext';
import ErrorNotificationComponent from './ErrorNotification';

interface Props {
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';
  maxNotifications?: number;
}

const NotificationContainer: React.FC<Props> = ({ 
  position = 'top-right',
  maxNotifications = 5
}) => {
  const { notifications, removeNotification } = useErrorNotification();

  const visibleNotifications = notifications.slice(0, maxNotifications);

  return (
    <Box
      style={{
        position: 'fixed',
        zIndex: 9999,
        pointerEvents: 'none',
        ...(position.includes('top') ? { top: 16 } : { bottom: 16 }),
        ...(position.includes('right') ? { right: 16 } : position.includes('left') ? { left: 16 } : { left: '50%', transform: 'translateX(-50%)' })
      }}
    >
      {visibleNotifications.map((notification, index) => (
        <Box
          key={notification.id}
          style={{
            pointerEvents: 'auto',
            marginBottom: 8,
            transform: `translateY(${index * 8}px)`,
            transition: 'transform 0.3s ease-in-out'
          }}
        >
          <ErrorNotificationComponent
            notification={notification}
            onClose={removeNotification}
            position={position}
          />
        </Box>
      ))}
    </Box>
  );
};

export default NotificationContainer;
